import { getData, getDataIx0 } from "../../../services/library";
import { UrlApi } from "../../../services/apirest";

export const ApiServices = {
    getComprobantes: (setcomprobantes) =>
        getData(`/facturacion_tipos_comprobantes`, setcomprobantes),

    getSucursales: (setSucursales) =>
        getData("/sucursales", setSucursales),

    getImpuestos: (setImpuestos) =>
        getData("/impuestos", setImpuestos),

    getValorPorcentajes: (setvalorPorcentajes) =>
        getData("/porcentaje_iva", setvalorPorcentajes),

    getCondicionesPago: (setcondicionesPago) =>
        getData("/condicion_pago", setcondicionesPago),

    getTipoMonedas: (settipoMonedas) =>
        getData("/desplegables/tipoMoneda", settipoMonedas),

    getMaximoFactura: (setMontoMaximoSinOC) =>
        getDataIx0("/desplegables/montoMaximoFactura", setMontoMaximoSinOC),

    getEmpresas: (setEmpresas) =>
        getData("/empresas", setEmpresas),

    getAdjuntos: (uuid, setAdjuntos) =>
        getData(`/uploadfiles/todownload/${uuid}`, setAdjuntos),

    getProveedores: async (busqueda, setloading, callback) => {
        setloading(true);
        try {
            // Usamos await para obtener la data antes de seguir
            const res = await fetch(`${UrlApi}/proveedores_padron/search?query=${encodeURIComponent(busqueda)}`);
            const data = await res.json();

            // Ejecutamos el callback pasándole la data
            callback(data);
        } catch (error) {
            console.error(error);
        } finally {
            setloading(false);
        }
    },

    getDatosCuerpo: async (uuid_comprobante, setDatosCuerpo) => {
        try {
            // Aquí podrías usar await para manipular la data antes del set
            const res = await fetch(`${UrlApi}/comprobantes_cuerpo/detalles/${uuid_comprobante}`);
            const data = await res.json();
            // Si el cuerpo es un array, podrías mapearlo para formatear importes
            setDatosCuerpo(data);
        } catch (error) {
            console.error("Error cargando cuerpo:", error);
        }
    },

    getDatosImpuestos: async (uuid_comprobante, setDatosImpuestos) => {
        try {
            // Aquí podrías usar await para manipular la data antes del set
            const res = await fetch(`${UrlApi}/comprobantes_cuerpo/impuestos/${uuid_comprobante}`);
            const data = await res.json();
            // Si el cuerpo es un array, podrías mapearlo para formatear importes
            setDatosImpuestos(data);
        } catch (error) {
            console.error("Error cargando cuerpo:", error);
        }
    },

    getDatosPie: async (uuid_comprobante, setDatosPie) => {
        try {
            const res = await fetch(`${UrlApi}/comprobantes_pie/xuuid/${uuid_comprobante}`);
            const data = await res.json();
            // El pie suele tener los totales, percepciones, etc.
            setDatosPie(data || data); // Dependiendo si el back devuelve array o objeto
        } catch (error) {
            console.error("Error cargando pie:", error);
        }
    },

    getProveedorByCuit: async (cuit) => {
        try {
            const res = await fetch(`${UrlApi}/proveedores_padron/search?query=${cuit}`);
            const data = await res.json();
            // Devolvemos el objeto encontrado o null
            return data.length > 0 ? data[0] : null;
        } catch (error) {
            console.error("Error buscando por CUIT", error);
            return null;
        }
    },

    getImputaciones:(setImputaciones)=>
        getData("/imputacion_gastos", setImputaciones),

    getImputacionProveedor: (id, setImputacionProveedor) => 
    getData(`/imputacion_proveedores/xid/${id}`, setImputacionProveedor),

};

export const formatNumber = (value) => {
    if (!value) return "";

    value = value?.replace(/[^\d,]/g, "");

    if (/^\d+(,)?$/.test(value)) {
        const numeric = value.replace(",", "");
        const formatted = numeric.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        return value.endsWith(",") ? formatted + "," : formatted;
    }

    const [integerPart, decimalPart] = value.split(",");
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    return decimalPart !== undefined
        ? `${formattedInteger},${decimalPart}`
        : formattedInteger;
};

export const handleOnChangeTotal = (e, setTotal, setTotalMuestro) => {
    const value = e.target.value;

    if (value === "") {
        setTotal(0);
        setTotalMuestro("");
        return;
    }

    // Convertimos a float puro para la base de datos (quitando puntos de miles)
    const numericValue = parseFloat(
        value.replace(/\./g, "").replace(",", ".")
    );

    if (!isNaN(numericValue)) { 
        setTotal(numericValue);
    }

    // Formateamos para la vista
    setTotalMuestro(formatNumber(value));
};

export const formatoCalculo = (valor) => {
    return parseFloat(valor.replace(/\./g, "")?.replace(/,/g, "."));
  }